<div class="itd" [class.itd--open]="isOpen" cdkOverlayOrigin #origin="cdkOverlayOrigin"
    (click)="toggle(); $event.stopPropagation()">
    <span class="itd__value">{{ selectedLabel }}</span>
    <svg class="itd__chevron" [class.itd__chevron--up]="isOpen" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4 6l4 4 4-4" stroke="#5F7081" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</div>

<ng-template cdkConnectedOverlay #connectedDrop="cdkConnectedOverlay" [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen" [cdkConnectedOverlayWidth]="overlayWidth"
    [cdkConnectedOverlayHasBackdrop]="false" [cdkConnectedOverlayScrollStrategy]="overlayScrollStrategy"
    [cdkConnectedOverlayPositions]="overlayPositions" [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8" [cdkConnectedOverlayPanelClass]="overlayPanelClass"
    (detach)="onOverlayDetach()">
    <div class="itd__panel" [style.max-height.px]="panelMaxHeight" (mousedown)="onPanelMouseDown()">
        <button *ngFor="let opt of options" type="button" class="itd__option"
            [class.itd__option--active]="opt.value === value" (mousedown)="select(opt); $event.preventDefault()">
            {{ opt.label }}
        </button>
    </div>
</ng-template>